import { Field } from 'SourceUtil/Query';

export class QuestionQuery {
    getQuestionListQuery(customer_email) {
        return new Field('questions')
            .addArgument('customer_email', 'String!', customer_email)
            .addFieldList(this.getProductQuestionsFields());
    }

    getProductQuestionsQuery(id, page) {
        return new Field('questions')
            .addArgument('pageSize', 'Int!', 5)
            .addArgument('product_id', 'Int!', id)
            .addArgument('currentPage', 'Int!', page)
            .addFieldList(this.getProductQuestionsFields());
    }

    getProductQuestionsFields() {
        return [
            this.getProductQuestionsList(),
            'total_pages',
            'total_questions'
        ];
    }

    getProductQuestionsList() {
        return new Field('questions').addFieldList(this.getProductQuestionsListFields());
    }

    getProductQuestionsListFields() {
        return [
            // this.getProductQuestionsUsers(),
            // this.getProductQuestions()
            'name',
            'question',
            'email',
            'age',
            'sex',
            'tip_par',
            'tip_ten',
            'answer_email',
            'created_at',
            'question_id',
            'answer'
        ];
    }

    getProductQuestionsUsers() {
        return new Field('users', [
            
        ])
    }

    getQuestionListFields(isList) {
        return [
            this.getQuestionItemsField(isList)
        ];
    }

    getQuestionItemsField(isList) {
        return new Field('items')
            .addFieldList(this.getQuestionItemsFields(isList));
    }

    getQuestionItemsFields(isList) {
        return [
            this.getBaseQuestionInfoField(isList)
            // ...(!isList ? [
            //     this._getPaymentInfoField(),
            //     this._prepareShippingInfo(),
            //     this._getOrderProductsField()
            // ] : [])
        ];
    }

    getBaseQuestionInfoField(isList) {
        return new Field('base_question_info')
            .addFieldList(this.getBaseQuestionInfoFields(isList));
    }

    getBaseQuestionInfoFields(isList) {
        return [
            'id',
            'created_at',
            'question_text',
            'answer_text'
        ];
    }

    getAddProductQuestionMutation(details) {
        return new Field('addProductQuestions')
            .addArgument('input', 'QuestionInput!', details)
            .addFieldList(this.getAddProductQuestionFields());
    }

    getAddProductQuestionFields() {
        return [
            'detail'
        ];
    }
}


export default new QuestionQuery();
